export default __webpack_public_path__ + "static/media/vip-header-new.f81caf6b.png";